/**
 * @fileoverview POST handler for the "/engagement/in_app_message_color_profiles/update_archived_state" endpoint
 */
import { FetchRequestError } from "@lib/errors";
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementInAppMessageColorProfilesUpdateArchivedStateCacheKeys } from "./constants";
import type {
  EngagementInAppMessageColorProfilesUpdateArchivedStateSuccessResult,
  PostEngagementInAppMessageTemplateUpdateArchivedStateProps,
} from "./types";
import { isErrorResult } from "./types";

export const postEngagementInAppMessageColorProfilesUpdateArchivedState = reactQueryMutationAdapter(
  engagementInAppMessageColorProfilesUpdateArchivedStateCacheKeys,
  ({
    appGroupId,
    ids,
    mark_as_archived,
  }: PostEngagementInAppMessageTemplateUpdateArchivedStateProps): Promise<EngagementInAppMessageColorProfilesUpdateArchivedStateSuccessResult> => {
    return fetch("/engagement/in_app_message_color_profiles/update_archived_state", "POST", {
      ids,
      mark_as_archived,
      app_group_id: appGroupId,
    }).then((result) => {
      if (isErrorResult(result)) {
        throw new FetchRequestError(400, result.warn);
      }
      return { ...result, undo_data: { ...result.undo_data, reenable: [] } };
    });
  }
);
